export default "__VITE_ASSET__36f5440e__"